import throttle from 'lodash.throttle';
import React, { memo, useCallback } from 'react';

import { RecordBooleanType } from '../../../types';
import { Adjustment } from '../config';
import { AdjustmentsPanelItem } from './AdjustmentsPanelItem';

export interface AdjustmentsPanelProps {
  adjustments: Adjustment[];
  adjustmentsInCollision: RecordBooleanType;
  disabled: boolean;
  hoveredAdjustmentId: string | null;
  previewAndCloseAllOtherAdjustments: (adjustmentId: string) => void;
  setHoveredAdjustmentId: (adjustmentId: string | null) => void;
  setPreOpenedAdjustmentId: (adjustmentId: string[]) => void;
  title: React.ReactNode;
  timezone: string;
}

export const AdjustmentsPanelComponent: React.FC<AdjustmentsPanelProps> = ({
  adjustments,
  adjustmentsInCollision,
  disabled,
  hoveredAdjustmentId,
  previewAndCloseAllOtherAdjustments,
  setHoveredAdjustmentId,
  setPreOpenedAdjustmentId,
  title,
  timezone,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChangeHoveredAdjustmentId = useCallback(
    throttle((adjustmentId: string | null) => {
      setHoveredAdjustmentId(adjustmentId);
    }, 10),
    []
  );

  return (
    <>
      <span className="forecasting-studio__adjustments-panel__title">{title}:</span>
      <div className="forecasting-studio__adjustments-panel__badges-wrapper">
        {adjustments.map((adjustment) => (
          <AdjustmentsPanelItem
            adjustment={adjustment}
            disabled={disabled}
            changeHoveredAdjustmentId={handleChangeHoveredAdjustmentId}
            inCollision={!!adjustmentsInCollision[adjustment.id]}
            isOpen={hoveredAdjustmentId === adjustment.id}
            key={adjustment.id}
            previewAndCloseAllOtherAdjustments={previewAndCloseAllOtherAdjustments}
            setPreOpenedAdjustmentId={setPreOpenedAdjustmentId}
            timezone={timezone}
          />
        ))}
      </div>
    </>
  );
};

export const AdjustmentsPanel = memo(AdjustmentsPanelComponent);
